export const BG_PRIMARY = 'rgba(6,6,6,1)';
export const BG_SECONDARY = 'rgba(255,251,251,1)';

export const TEXT_PRIMARY = '#FFFFFF';
export const TEXT_SECONDARY = '#0C0C0C';
export const TEXT_ALTERNATIVE = '#FFFFFF';

export const BTN_NAVIGATION_COLOR = '#edf2f7';
export const ICON_NAVIGATION_COLOR = '#000';

export const DEFAULT_BUTTON_PROPS = '';
